import {
  useGetAnalyticsDataQuery,
  type TGetAnalyticsData,
} from "@/shared/services";
import useGetQueryData from "./use-get-query-data";
import { useShowPlaceholderData } from "./use-show-placeholder-data";

export const useAnalyticsQuery = ({
  query,
  overrides = {},
  enabled = true,
  skipDebounce = false,
}: {
  query: TGetAnalyticsData["query"];
  overrides?: Partial<TGetAnalyticsData["params"]>;
  enabled?: boolean;
  skipDebounce?: boolean;
}) => {
  const demo = useShowPlaceholderData();
  const params = { ...useGetQueryData(skipDebounce), ...overrides };
  return useGetAnalyticsDataQuery({
    query,
    params: { demo, ...params, ...overrides },
    enabled,
  });
};
